import React from 'react';
import { Sparkles, ShieldCheck, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

export const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="home" className="relative pt-24 pb-20 md:pt-32 md:pb-32 overflow-hidden">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1585421514738-01798e348b17?w=1200"
          alt="Professional cleaning service"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/90 to-[#0B7CB5]/20"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center space-x-2 bg-[#0B7CB5]/10 px-4 py-2 rounded-full mb-6 animate-in fade-in slide-in-from-bottom-3 duration-700">
            <Sparkles className="w-5 h-5 text-[#0B7CB5]" />
            <span className="text-[#0B7CB5] font-semibold text-sm">Trusted Cleaning Professionals</span>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
            A Cleaner Space Starts Here —{' '}
            <span className="text-[#0B7CB5]">Trusted, Professional</span> Cleaning
          </h1>

          <p className="text-xl text-gray-700 mb-8 leading-relaxed animate-in fade-in slide-in-from-bottom-5 duration-700 delay-200">
            Serving Richmond, VA with reliable, detail-oriented residential and commercial cleaning services.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12 animate-in fade-in slide-in-from-bottom-6 duration-700 delay-300 relative z-20">
            <a 
              href="tel:+18045837000"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-all h-10 bg-[#0B7CB5] hover:bg-[#095a87] text-white text-lg px-8 py-6 hover:shadow-xl hover:scale-105 no-underline"
              style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'transparent', position: 'relative', zIndex: 20 }}
            >
              <Phone className="mr-2 w-5 h-5" />
              Call or Text (804) 583-7000
            </a>
            <Button
              onClick={() => navigate('/calculator')}
              size="lg"
              variant="outline"
              className="border-2 border-[#0B7CB5] text-[#0B7CB5] hover:bg-[#0B7CB5] hover:text-white text-lg px-8 py-6 transition-all duration-200 hover:shadow-xl"
            >
              Get Instant Estimate
            </Button>
          </div>

          <div className="inline-flex items-center space-x-3 bg-white/80 backdrop-blur-sm px-6 py-4 rounded-lg shadow-lg animate-in fade-in slide-in-from-bottom-7 duration-700 delay-400">
            <ShieldCheck className="w-6 h-6 text-[#0B7CB5]" />
            <div>
              <p className="font-semibold text-gray-900">Licensed, Insured & SWaM Certified</p>
              <p className="text-sm text-gray-600">20+ Years Combined Experience</p>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-[#5CC4E8]/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-10 left-10 w-96 h-96 bg-[#0B7CB5]/5 rounded-full blur-3xl pointer-events-none"></div>
    </section>
  );
};